import logoUrl from '@/assets/AzimutLogo.png';

type AzimutLogoProps = {
  alt?: string;
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
};

export const AzimutLogo = ({
  alt = 'Azimut logo',
  className,
  width,
  height,
  priority = true,
}: AzimutLogoProps) => (
  <img
    src={logoUrl}
    alt={alt}
    width={width}
    height={height}
    className={className}
    loading={priority ? 'eager' : 'lazy'}
    decoding="async"
    fetchPriority={priority ? 'high' : 'auto'}
    draggable={false}
  />
);
